import { useState } from "react";
import { api } from "@/lib/api";
import {
	previewKind,
	type PreviewKind,
} from "@/components/workspace/workspace-file-icons";

/** State of the file preview modal: which file, and whether its URL loaded. */
export function useFilePreview(projectId: string | undefined) {
	const [previewModalOpen, setPreviewModalOpen] = useState(false);
	const [previewUrl, setPreviewUrl] = useState<string | null>(null);
	const [previewKindState, setPreviewKind] = useState<PreviewKind>("other");
	const [previewLoading, setPreviewLoading] = useState(false);
	const [previewError, setPreviewError] = useState<string | null>(null);

	const handleFilePreview = async (
		fileId: string,
		mimeType?: string | null,
		name?: string | null,
	) => {
		if (!projectId) return;
		setPreviewModalOpen(true);
		setPreviewLoading(true);
		setPreviewError(null);
		setPreviewUrl(null);
		setPreviewKind(previewKind(mimeType ?? null, name));

		try {
			const { signedUrl } = await api.getProjectFileSignedUrl(
				projectId,
				fileId,
			);
			setPreviewUrl(signedUrl);
		} catch (err) {
			setPreviewError(
				err instanceof Error ? err.message : "Failed to load file preview",
			);
		} finally {
			setPreviewLoading(false);
		}
	};

	return {
		open: previewModalOpen,
		url: previewUrl,
		kind: previewKindState,
		loading: previewLoading,
		error: previewError,
		openPreview: handleFilePreview,
		close: () => setPreviewModalOpen(false),
	};
}
